import axios from "axios"

const tokenizeCard = async (payrixUrl, businessKey, card) => {
    const url = `${payrixUrl}/businesses/${businessKey}/services/tokenize-card`;

    const response = await axios.post(url, {
        Card: { ...card }
    })

    return await response.data;
}

export {
    tokenizeCard,
}